import { toast } from 'sonner';
import { useMutation } from '@apollo/client/react';

import { AddUserDocument } from 'src/graphql/actions/user/addUser.mutation';
import { ClientError, getApiError } from 'src/utils/errors';
import { UserForm, type IUserForm } from 'src/components/User';

import { useUsers } from '../model';

const AddUser = () => {
  const {
    ui: { closeDialog, confirmInvitation },
    refetchUsers,
  } = useUsers();
  const [addMember] = useMutation(AddUserDocument, {
    onCompleted: refetchUsers,
  });

  const onSubmit = async (dataForm: IUserForm) => {
    try {
      const { data } = await addMember({
        variables: {
          users: [
            {
              name: dataForm.fullName,
              email: dataForm.email,
              role: dataForm.role,
              phone: dataForm.phone,
            },
          ],
        },
      });

      if (data?.addUser?.success) {
        confirmInvitation();
      } else {
        throw new ClientError(data?.addUser?.errors?.[0]);
      }
    } catch (error) {
      getApiError(error, toast.error);
    }
  };

  return <UserForm onSubmit={onSubmit} onCancel={closeDialog} btnText="Send invitation" />;
};

export default AddUser;
